import React, { useEffect } from 'react';
import { SeoBar } from '../components/SeoBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HeroSection } from './five-axis-benefits/HeroSection';
import { BenefitsSection } from './five-axis-benefits/BenefitsSection';
import { RelatedLinkSection } from './five-axis-benefits/RelatedLinkSection';
export function FiveAxisBenefitsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-2299">
      <SeoBar data-id="element-2300" />
      <Header data-id="element-2301" />
      <main className="flex-grow" data-id="element-2302">
        <div className="w-full bg-gray-50 pb-20" data-id="element-2303">
          <HeroSection data-id="element-2304" />
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12 space-y-12" data-id="element-2305">
            <BenefitsSection data-id="element-2306" />
            <RelatedLinkSection data-id="element-2307" />
          </div>
        </div>
      </main>
      <Footer data-id="element-2308" />
    </div>;
}